module.exports = __webpack_public_path__ + "static/img/cp.a2e8c9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cp.png
// module id = mRUF
// module chunks = 1